<ng-container [formGroup]="formGroup">
  <div class="product-section">
    <div class="product-fields">
      <pdq-input
        [formControl]="formGroup.get('settings.productDetails.variantId')"
        label="Product Or Variant ID*"
        [invalid]="formGroup.get('settings.productDetails.variantId').invalid"
        [invalidMsg]="formGroup.get('settings.productDetails.variantId').errors?.required ? requiredFieldMessage : ''">
      </pdq-input>
      <pdq-input
        [formControl]="formGroup.get('settings.productDetails.sellingPlanId')"
        label="Selling Plan ID*"
        [invalid]="formGroup.get('settings.productDetails.sellingPlanId').invalid"
        [invalidMsg]="
          formGroup.get('settings.productDetails.sellingPlanId').errors?.required ? requiredFieldMessage : ''
        ">
      </pdq-input>
    </div>
    <div class="product-info">
      <span>The gift unlock banner won't be shown if the product is out of stock</span>
      <pdq-link
        class="product-link"
        label="Where to find the Product or Variant ID"
        [external]="true"
        url="https://support.prettydamnquick.com/en/articles/9227241-adding-gift-unlock-to-your-checkout">
      </pdq-link>
    </div>
  </div>

  @if (!isAutoApplyEnabled) {
    <pdq-checkbox
      [formControl]="formGroup.get('settings.productDetails.hideOfferDetails')"
      label="Hide Product Details From Pop Up"
      labelSize="small">
    </pdq-checkbox>
  }
  <div class="hide-in-cart-section">
    <pdq-checkbox
      [formControl]="formGroup.get('settings.productDetails.hideIfProductIsInCart')"
      label="Hide Offer If The User Already Has This Product In Their Cart"
      labelSize="small">
    </pdq-checkbox>
    @if (formGroup.get('settings.productDetails.hideIfProductIsInCart').value) {
      <div #hideInCartLevel class="hide-in-cart-level">
        <span class="hide-in-cart-level__title body-14-medium">Detection Level</span>
        <pdq-radio-group [formControl]="formGroup.get('settings.productDetails.hideIfProductIsInCartLevel')">
          @for (option of hideInCartLevelOptions; track option.value) {
            <pdq-radio-button
              [value]="option.value"
              [checked]="formGroup.get('settings.productDetails.hideIfProductIsInCartLevel').value === option.value"
              [text]="option.label"
              [subText]="option.description">
            </pdq-radio-button>
          }
        </pdq-radio-group>
      </div>
    }
  </div>

  <pdq-checkbox
    [formControl]="formGroup.get('settings.productDetails.discountConfiguration.enabled')"
    label="Set Discount Configuration"
    labelSize="small">
  </pdq-checkbox>
  @if (formGroup.get('settings.productDetails.discountConfiguration.enabled')?.value) {
    <div class="flex-row">
      <pdq-dropdown
        [formControl]="formGroup.get('settings.productDetails.discountConfiguration.discountType')"
        title="Discount Type"
        [options]="couponTypeOptions"
        optionLabel="label"
        optionValue="value">
      </pdq-dropdown>
      <pdq-input-arrows
        [formControl]="formGroup.get('settings.productDetails.discountConfiguration.discountValue')"
        label="Discount value"
        widthSize="auto"
        precision="2"
        min="1"
        [max]="
          formGroup.get('settings.productDetails.discountConfiguration.discountType').value === CouponType.PERCENTAGE
            ? 100
            : undefined
        "
        [symbol]="
          formGroup.get('settings.productDetails.discountConfiguration.discountType').value === CouponType.PERCENTAGE
            ? '%'
            : shopCurrencySymbol
        ">
      </pdq-input-arrows>
    </div>
  }

  <pdq-input [formControl]="formGroup.get('giftPopup.title')" label="Pop Up Display Title"> </pdq-input>
  <pdq-input [formControl]="formGroup.get('giftPopup.text')" label="Pop Up Display Subtitle"> </pdq-input>
  <pdq-input
    [formControl]="formGroup.get('giftPopup.actionButtonText')"
    label="Call To Action Button Text"
    [tooltip]="'Adds the offer selling plan product to the order'">
  </pdq-input>
  <pdq-input
    [formControl]="formGroup.get('giftPopup.declineButtonText')"
    label="Decline Button Text"
    [tooltip]="'Closes the pop up'">
  </pdq-input>
</ng-container>
